module.exports = __webpack_public_path__ + "static/img/number09.39cdc924.png";